import { render, staticRenderFns } from "./pageGap.vue?vue&type=template&id=f6e68d2c&scoped=true"
import script from "./pageGap.vue?vue&type=script&lang=ts"
export * from "./pageGap.vue?vue&type=script&lang=ts"
import style0 from "./pageGap.vue?vue&type=style&index=0&id=f6e68d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e68d2c",
  null
  
)

export default component.exports